var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButIntellikey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-87200209-6855-4dee-b012-11c7eabd1d58",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 31,
    viewBox: "0 0 150 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.538,7.383h3.025v15.188h-3.025V7.383Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.82,15.62v6.951h-2.853v-6.393c0-1.502-.515-2.167-1.566-2.167-.901,0-1.845.579-2.66,1.395v7.165h-2.853v-10.576h2.531l.129,1.566c1.051-1.18,2.338-1.995,3.904-1.995,2.124,0,3.368,1.437,3.368,4.054Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.381,19.289v-5.084h-1.759v-2.21h1.824v-2.21l2.21-1.33h.579v3.54h2.896v2.21h-2.896v4.655c0,1.309.386,1.673,1.33,1.673.472,0,.922-.107,1.352-.322l.214.107.064,2.274c-.622.257-1.502.408-2.274.408-2.381,0-3.54-1.223-3.54-3.711Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.565,18.023h-7.251c.107,1.695,1.18,2.724,2.746,2.724,1.137,0,2.467-.365,3.497-1.266h.107l.301,2.295c-1.073.708-2.639,1.223-4.162,1.223-3.454,0-5.406-2.338-5.406-5.685s2.059-5.749,5.234-5.749c3.132,0,4.956,2.21,4.956,5.599,0,.386,0,.515-.022.858Zm-2.66-1.781c-.086-1.63-.901-2.574-2.188-2.574-1.266,0-2.21.965-2.381,2.553l4.569.022Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.054,22.571V6.803h2.853v15.768h-2.853Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.974,22.571V6.803h2.853v15.768h-2.853Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.53,8.605c0-.944.751-1.652,1.781-1.652s1.781.729,1.781,1.652c0,.944-.751,1.673-1.781,1.673-1.008,0-1.781-.729-1.781-1.673Zm.365,13.965v-10.576h2.853v10.576h-2.853Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.109,13.84l5.792,8.624-.064.107h-3.497l-4.269-6.414-1.995,2.295v4.119h-3.025V7.383h3.025v2.639c0,1.437-.064,3.218-.107,4.741h.043c.923-1.201,1.781-2.317,2.66-3.347l3.411-4.033h3.497l.064.107-5.535,6.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.564,18.023h-7.251c.107,1.695,1.18,2.724,2.746,2.724,1.137,0,2.467-.365,3.497-1.266h.107l.301,2.295c-1.073.708-2.639,1.223-4.162,1.223-3.454,0-5.406-2.338-5.406-5.685s2.059-5.749,5.234-5.749c3.132,0,4.956,2.21,4.956,5.599,0,.386,0,.515-.022.858Zm-2.66-1.781c-.086-1.63-.901-2.574-2.188-2.574-1.266,0-2.21.965-2.381,2.553l4.569.022Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.769,11.995l1.03,3.518c.365,1.137.879,2.66,1.223,3.819h.064c.365-1.158.923-2.66,1.33-3.797l1.115-3.54h3.089l.086.086-6.393,15.21h-2.917l-.022-.086,2.124-4.934-3.99-10.19.086-.086h3.175Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.811,
    y: 0.428,
    width: 30.072,
    height: 30.072,
    rx: 3.759,
    ry: 3.759,
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.912,
    y: 1.529,
    width: 28.51,
    height: 27.87,
    rx: 3.524,
    ry: 3.524,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.404,
    y: 2.022,
    width: 26.885,
    height: 26.885,
    rx: 3.361,
    ry: 3.361,
    style: {
      fill: "#f6f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.846,25.607c-.192,0-.387-.06-.553-.185-1.496-1.127-2.354-2.847-2.354-4.719v-9.949c0-3.257,2.65-5.907,5.907-5.907s5.906,2.65,5.906,5.907v9.949c0,1.871-.858,3.591-2.352,4.718-.407.307-.983.225-1.29-.18-.306-.406-.225-.983.181-1.289,1.029-.776,1.62-1.96,1.62-3.248v-9.949c0-2.242-1.824-4.066-4.065-4.066s-4.066,1.824-4.066,4.066v9.949c0,1.288.591,2.472,1.62,3.248.406.306.487.883.182,1.289-.182.24-.457.367-.736.367Z",
    style: {
      fill: "#075571"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.847,26.081c-.509,0-.921-.412-.921-.921v-5.625c0-.508.412-.921.921-.921s.921.412.921.921v5.625c0,.508-.412.921-.921.921Z",
    style: {
      fill: "#075571"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.847,
    cy: 15.728,
    r: 1.156,
    style: {
      fill: "#075571"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButIntellikey);
export default __webpack_public_path__ + "static/media/butIntellikey.2b50211fed41bede5df1c6ebf2402471.svg";
export { ForwardRef as ReactComponent };